import { gql, TypedDocumentNode } from "@apollo/client";
import { NOTE_FIELDS } from "@graphql/fragments/note";

import {
  GetInboxNotesQuery,
  GetInboxNotesQueryVariables,
} from "./GetInboxNotes.generated";

const GET_INBOX_NOTES: TypedDocumentNode<
  GetInboxNotesQuery,
  GetInboxNotesQueryVariables
> = gql`
  ${NOTE_FIELDS}
  query getInboxNotes(
    $filter: String!
    $limit: Int
    $offset: Int
    $teamUuid: String
    $userUuids: [String]
    $startDate: DateTime
    $endDate: DateTime
    $sortAscending: Boolean
    $jobType: String
    $searchQuery: String
    $hasBeenExported: Boolean
  ) {
    inboxNotes(
      filter: $filter
      limit: $limit
      offset: $offset
      startDate: $startDate
      endDate: $endDate
      teamUuid: $teamUuid
      userUuids: $userUuids
      sortAscending: $sortAscending
      jobType: $jobType
      searchQuery: $searchQuery
      hasBeenExported: $hasBeenExported
    ) {
      totalNotes
      notes {
        patient {
          name
          lastNameOfOwner
          sex
          species
          uuid
        }
        autoTemplates {
          uuid
        }
        user {
          firstName
          lastName
          uuid
        }
        jobType
        ...NoteFields
      }
    }
  }
`;

export default GET_INBOX_NOTES;
